import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

const initialState = {
  articlePage: {  },
}

const NAME = 'articlePage';
export const articlePageSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    changeArticlePage: (state, action) => {
      state.articlePage = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload[NAME]
      }
    })
  }
})

export const { changeArticlePage } = articlePageSlice.actions;
export default articlePageSlice;
